import type { ActivityFeedEvent } from './types';
import { ACTIVITY_FEED_CONTENT_TYPE, ACTIVITY_FEED_MODULE } from './types';
import type { ActivityFeedItemDto, MentionDto } from './dto';

const EVENTS_COUNT_LIMIT = 15;

/* eslint-disable camelcase */
export function mapActivityFeedResponseDtoToModel(
  teamActivityEvents: ActivityFeedItemDto[],
): ActivityFeedEvent[] {
  return teamActivityEvents
    .slice(0, EVENTS_COUNT_LIMIT)
    .map(({ id, data, action, module, created_epoch_time: created, picture_url: pictureUrl }) => {
      // TODO: Remove after feed endpoint return "surveys" text.
      const isPollsModule = module === ACTIVITY_FEED_MODULE.POLLS;
      const passedModule = data.module_override || module;
      return {
        id,
        module: isPollsModule ? ACTIVITY_FEED_MODULE.SURVEYS : passedModule,
        created,
        pictureUrl,
        username: data.username,
        action: data.action || action,
        description: isPollsModule ? 'a survey' : data.description,
        linkText: data.link_name,
        linkUrl: data.url,
        content: data.content
          ? data.content.map(({ type, value }, index) => ({
              uuid: `${id}-${index}`,
              type,
              value:
                type === ACTIVITY_FEED_CONTENT_TYPE.MENTION
                  ? `@${(value as MentionDto)?.name}`
                  : (value as string),
            }))
          : null,
      };
    });
}
